import React from 'react';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
  const sections = [
    {
      title: "Introduction",
      content: "At EcoIndex, your privacy is one of our top priorities. This Privacy Policy explains how we collect, use, share, and protect your personal information when you use our platform—including both the EcoIndex mobile application and the web application—to track carbon emissions from daily activities or events and participate in our carbon credit reward program. By accessing or using EcoIndex via the mobile app or weblink, you agree to the practices described in this policy."
    },
    {
      title: "Information We Collect",
      content: `We collect the following categories of information, either directly from you or automatically, to provide and improve our services.\n
A. Information You Provide:\n• Name, email address, and phone number\n• Location details (for calculating emissions)\n• Travel, energy, food, or event-related data\n• Feedback or support queries, including attachments\n
B. Information Collected Automatically:\n• App/website usage data (e.g., pages visited, features used)\n• Device and browser information (model, OS, browser type, unique identifiers)\n• IP address and location data (if permissions are granted)\n• Cookies and other tracking technologies\n
We may also use third-party tools such as Google Firebase, Google Analytics, and social media SDKs (e.g., Facebook, Twitter, Instagram) to enhance your experience and support analytics, crash reporting, and performance optimization.`
    },
    {
      title: "How We Use Your Information",
      content: `We use your personal data to:\n• Provide and maintain EcoIndex functionality\n• Track and display personalized carbon emission data\n• Improve app and site performance and features\n• Respond to support requests\n• Send optional updates, notifications, and marketing (with your consent)\n• Ensure legal compliance`
    },
    {
      title: "Sharing of Information",
      content: `We do not sell your personal data. However, we may share data as follows:\n• With analytics and service providers (e.g., Firebase, Google Analytics)\n• With carbon credit partners and third-party verifiers (with strict privacy standards)\n• With legal authorities, if required by law`
    },
    {
      title: "Cookies and Tracking Technologies",
      content: `We use cookies and similar technologies to:\n• Analyze traffic and usage patterns\n• Customize content and improve functionality\nYou can manage cookie preferences via your browser or device settings.`
    },
    {
      title: "Data Security",
      content: `We implement industry-standard measures to protect your data, including:\n• Encryption\n• Secure data storage\n• Access controls\n• Regular security assessments`
    },
    {
      title: "Retention of Data",
      content: `We retain your data only as long as necessary to:\n• Deliver services\n• Fulfill legal obligations\n• Resolve disputes or enforce policies\nYou may request data deletion at any time, subject to legal constraints.`
    },
    {
      title: "Children’s Privacy",
      content: "EcoIndex does not knowingly collect data from children under 13. If you're a parent or guardian and believe your child has shared data with us, please contact us at connect@ecoindex.ai so we can delete the data promptly."
    },
    {
      title: "Carbon Credit Program",
      content: `If you choose to participate in the EcoIndex Carbon Credit Program:\n• Certain data may be shared with accredited third-party verifiers\n• All partners follow strict data privacy and security guidelines`
    },
    {
      title: "Third-Party Services",
      content: `We may integrate with or use third-party tools such as:\n• Google Firebase, Google Analytics\n• Facebook, Twitter, Instagram SDKs or login services\nEach third party may collect data according to their own privacy policies.`
    },
    {
      title: "Your Rights",
      content: `You have the right to:\n• Access or request deletion of your data\n• Withdraw consent at any time (where applicable)\n• Request data portability or correction\nTo exercise these rights, contact us at connect@ecoindex.ai.`
    },
    {
      title: "Changes to This Privacy Policy",
      content: `We may update this policy from time to time. When we do, we will notify you through:\n• Email, and/or\n• Prominent notices in the app or on the website`
    },
    {
      title: "Contact Us",
      content: "If you have any questions, concerns, or requests related to this Privacy Policy, reach out to us at: connect@ecoindex.ai"
    }
  ];

  return (
    <div className="privacy-container">
      <h1 className="privacy-title">Privacy Policy</h1>
      {sections.map((section, index) => (
        <div key={index} className="privacy-section">
          <h2 className="section-title">{section.title}</h2>
          <p className="section-content">
          {section.content.split('\n').map((line, i) => (
              <span key={i}>
                {line}
                <br />
              </span>
            ))}
          </p>
        </div>
      ))}
    </div>
  );
};

export default PrivacyPolicy;
